import React, { useState } from "react";
import ButtonComponent from "../../../components/commonComponent/ButtonComponent";
import "../../../components/commonComponent/colorChangingBorder.css";

const MAX_PROMPT_LENGTH = 4000;

const CanvasAiComposer = ({ canSend, onSend, onStop, status }) => {
  const [prompt, setPrompt] = useState("");
  const isStreaming = status === "streaming";

  const submitPrompt = async () => {
    const cleanPrompt = prompt.trim();
    if (!cleanPrompt || !canSend || isStreaming) return;
    setPrompt("");
    await onSend(cleanPrompt);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    await submitPrompt();
  };

  const handleKeyDown = async (event) => {
    if (event.key !== "Enter" || event.shiftKey) return;
    event.preventDefault();
    await submitPrompt();
  };

  return (
    <form className="canvas-ai-composer" onSubmit={handleSubmit}>
      <div className="canvas-ai-composer-field title-input-netpad-hairline title-input-balanced-shadow">
        <textarea
          aria-label="Message AI diagram assistant"
          className="canvas-ai-composer-input"
          disabled={!canSend || isStreaming}
          maxLength={MAX_PROMPT_LENGTH}
          onChange={(event) => setPrompt(event.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={canSend ? "Describe a diagram or change…" : "Select a model first"}
          rows={2}
          value={prompt}
        />
      </div>
      {isStreaming ? (
        <button className="canvas-ai-button canvas-ai-button--danger" onClick={onStop} type="button">
          Stop
        </button>
      ) : (
        <ButtonComponent
          buttonName="Send"
          disabled={!canSend || !prompt.trim()}
          size="compact"
          tone="actionSave"
          type="submit"
        />
      )}
    </form>
  );
};

export default CanvasAiComposer;
